<div class="mt-3 container-fluid animate__animated animate__slideInUp">
    <mat-card>
        <mat-card-title>Generar Resumen Haberes</mat-card-title>
    </mat-card>
    <br>
    <mat-card>
        <mat-card-content>
            <app-generar-resumen-haberes [empresas]="empresas"></app-generar-resumen-haberes>
        </mat-card-content>
    </mat-card>
</div>